'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'clapperboard-play';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e132';
var svgPathData = 'M496 176l0 240c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48l0-240 480 0zm0-16l-124.7 0L475 56.3C487.7 65 496 79.5 496 96l0 64zm-276.7 0L325.7 53.7l5.7-5.7L448 48c3.9 0 7.7 .5 11.3 1.3L348.7 160l-129.4 0zm-22.6 0L67.3 160 173.7 53.7l5.7-5.7 129.4 0-112 112zM64 48l92.7 0L44.7 160 16 160l0-64c0-26.5 21.5-48 48-48zM512 160l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64 0 8 0 8L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-240 0-8 0-8zM204.2 225.2c-2.5-1.5-5.6-1.6-8.1-.2s-4.1 4.1-4.1 7l0 176c0 2.9 1.6 5.6 4.1 7s5.6 1.4 8.1-.2l144-88c2.4-1.5 3.8-4 3.8-6.8s-1.4-5.4-3.8-6.8l-144-88zM328.7 320L208 393.7l0-147.5L328.7 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faClapperboardPlay = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;